{
    "CIV_QOK43I37KkxIezcPx": {
        "key": "CIV_QOK43I37KkxIezcPx",
        "position": {
            "x": 13,
            "y": 9,
            "z": 1
        },
        "tag": "top-spawn"
    },
    "8pBpRr2AwlsGO2a0BpC6A": {
        "key": "8pBpRr2AwlsGO2a0BpC6A",
        "position": {
            "x": 14,
            "y": 13,
            "z": 1
        },
        "tag": "top-spawn"
    },
    "UDk2c9VbE5_89aug9TH6u": {
        "key": "UDk2c9VbE5_89aug9TH6u",
        "position": {
            "x": 13,
            "y": 10,
            "z": 1
        },
        "tag": "top-spawn"
    },
    "oGl24jc5anF-dws8eXOU7": {
        "key": "oGl24jc5anF-dws8eXOU7",
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "tag": "top-spawn"
    },
    "buUtlfMwhr5hQgpebopEg": {
        "key": "buUtlfMwhr5hQgpebopEg",
        "position": {
            "x": 16,
            "y": 19,
            "z": 1
        },
        "tag": "bottom-spawn"
    },
    "k-pvhn3PCUi7mgAffSXNC": {
        "key": "k-pvhn3PCUi7mgAffSXNC",
        "position": {
            "x": 16,
            "y": 20,
            "z": 1
        },
        "tag": "bottom-spawn"
    },
    "ZImNNL4_iqahA6upUc_Xq": {
        "key": "ZImNNL4_iqahA6upUc_Xq",
        "position": {
            "x": 14,
            "y": 16,
            "z": 1
        },
        "tag": "bottom-spawn"
    },
    "B4QEKqg0h9cRwRrrZqwmI": {
        "key": "B4QEKqg0h9cRwRrrZqwmI",
        "position": {
            "x": 15,
            "y": 16,
            "z": 1
        },
        "tag": "bottom-spawn"
    }
}